<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Nachweis zu einem Profil hinzufügen</h3>
                </div>
            </div>
        </div>
        <template>
            <form @submit.prevent="create">
                <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                <h6 class="heading-small text-muted mb-4">Angaben zum Nachweis</h6>
                <profile-document-form :profile="$route.params.profile" :type="$route.params.type" ref="PDForm"/>
                <button :key="'btn'+key" v-if="showSubmitButton"  class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                    <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                    <span class="btn-inner--text">Nachweis anlegen</span></button>
            </form>
        </template>
    </card>
</template>

<script>
    import ProfileDocumentForm from "@/views/ProfileDocuments/profiledocumentform";
    export default {
        name:"create-profiledocument",
        components:{ProfileDocumentForm},
        data() {
            return {
                isLoadingData: false,
                key: 1,
                mount: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            //if (!this.$store.getters['profiles/isReady'] && !this.$store.getters['profiles/isLoading']) {
            //    this.$store.dispatch('profiles/getProfiles'); }
        },
        mounted() {

            this.mount = true;
            /*
            if (typeof this.$route.params.profile !== 'undefined') {
               this.$refs.PDForm.profileDocument.profile = '/api/profiles/'+this.$route.params.profile;
           }*/
        },
        computed: {
           isLoading() {
               return (this.isLoadingData || this.$store.getters['profiles/isloading'] || this.$store.getters['customer/isloading']);
           },
           showSubmitButton() {
               return (this.mount) ? (this.$refs.PDForm.mode === 'form' || this.$refs.PDForm.edit) ? true : false : false;
           }
        },
        methods: {
            create() {
                this.$store.dispatch('alert/clear');
                    this.isLoadingData = true;
                    this.key++;
                    this.createProfileDocument()
                        .then(response => {
                            this.isLoadingData = false;
                            this.status =  {type: 'success', msg: 'Nachweis zum Profil (ID: '+response.id+') wurde erstellt. '};
                            this.$store.dispatch('alert/success',this.status.msg);
                            this.$router.push('/users/profiles_documents');
                        })
                        .catch(error => {
                            this.isLoadingData = false;
                            this.status =  {type: 'danger', msg: error};
                            this.key++;
                        })
            },
            createProfileDocument() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.$refs.PDForm.profileDocument;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profile_documents`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

<style scoped>

</style>